<template>
  <ul v-if="receipts && receipts.length" class="mr-list" :aria-label="$gt('Empfangsbestätigungen')">
    <li v-for="r in receipts" :key="r.id" class="mr-item" :class="'mr-item--' + r.kind">
      <CheckCheck v-if="r.kind === 'read'" :size="13" />
      <MailCheck v-else :size="13" />
      <span class="mr-item__text">{{ label(r) }}</span>
    </li>
  </ul>
</template>

<script>
import { CheckCheck, MailCheck } from "lucide-vue-next";

/**
 * Systemzeilen für Übertragungs-/Lesebestätigungen an einer Nachricht
 * (Inhaber-Feedback 15.08.2026, I.3): „Zugestellt an … am …“ bzw.
 * „Gelesen von … am …“. Das Backend liefert Bestätigungen nur dem
 * Verfasser der jeweiligen Nachricht (attachReceipts) – hier wird daher
 * nichts mehr gefiltert, nur angezeigt.
 */
export default {
  name: "MessageReceipts",

  components: { CheckCheck, MailCheck },

  props: {
    /** Bestätigungen der Nachricht (Backend: message.receipts). */
    receipts: { type: Array, default: () => [] },
  },

  methods: {
    who(r) {
      const name = (r.recipientName || "").trim();
      if (name) return name;
      const rec = r.recipient || "";
      return rec.startsWith("user:") ? this.$gt("Empfänger") : rec;
    },
    when(iso) {
      if (!iso) return "";
      const d = new Date(iso);
      if (isNaN(d.getTime())) return "";
      return d.toLocaleString("de-DE", {
        day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
      });
    },
    label(r) {
      const tpl = r.kind === "read"
        ? this.$gt("Gelesen von {name} am {date}")
        : this.$gt("Zugestellt an {name} am {date}");
      return tpl.replace("{name}", this.who(r)).replace("{date}", this.when(r.createdAt));
    },
  },
};
</script>

<style scoped>
.mr-list {
  list-style: none;
  margin: 6px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.mr-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.74rem;
  color: #15803d;
  padding: 3px 8px;
  border-radius: 6px;
  background: rgba(22, 163, 74, 0.07);
  border: 1px solid rgba(22, 163, 74, 0.18);
  width: fit-content;
  max-width: 100%;
}
.mr-item--delivery {
  color: #1d4ed8;
  background: rgba(37, 99, 235, 0.07);
  border-color: rgba(37, 99, 235, 0.18);
}
.mr-item__text { overflow-wrap: anywhere; }
</style>
